import React from 'react';
import { Button } from './ui/Button';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve para mujeres en menopausia completa?',
    a: 'Sí. El combo está diseñado específicamente para perimenopausia, menopausia y postmenopausia. El Tomo 1 explica exactamente qué ocurre en cada etapa y el Tomo 5 incluye un protocolo específico para mujeres que ya no menstrúan.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Inmediatamente después del pago recibís un email con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.'
  }, {
    q: '¿Qué lo diferencia de otras guías de pérdida de peso?',
    a: 'Está diseñado para la biología femenina específica de 40+, con ingredientes del supermercado argentino, adaptado a la vida real con hijos, trabajo y eventos sociales. No es una dieta genérica traducida del inglés.'
  }, {
    q: '¿Necesito contar calorías o macros?',
    a: 'No. El sistema no se basa en contar calorías. Se basa en equilibrar hormonas, elegir los alimentos correctos y respetar los horarios que tu cuerpo necesita.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total sin preguntas. Si en 7 días no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios ni explicaciones.'
  }, {
    q: '¿Puedo comprarlo si tengo hipotiroidismo o diabetes?',
    a: 'El material es educativo e informativo y no reemplaza la consulta médica. Si tenés condiciones médicas preexistentes, te recomendamos compartir el contenido con tu médico antes de aplicar los protocolos.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white text-black py-24 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="font-display font-black text-4xl md:text-5xl uppercase mb-4" data-id="element-35">
            Lo que más nos preguntan
          </h2>
        </div>

        <div className="space-y-6 mb-24" data-id="element-36">
          {faqs.map((faq, i) => <div key={i} className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8" data-id="element-37">
              <h3 className="font-display font-bold text-xl mb-3 text-brand" data-id="element-38">
                {faq.q}
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-39">{faq.a}</p>
            </div>)}
        </div>

        {/* COST OF INACTION */}
        <div className="bg-black text-white rounded-3xl p-8 md:p-12 mb-24 shadow-2xl" data-id="element-40">
          <h3 className="font-display font-black text-3xl md:text-4xl uppercase text-center mb-10" data-id="element-41">
            ¿Cuánto cuesta no tenerlo?
          </h3>

          <div className="space-y-6" data-id="element-42">
            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-43">
              <div className="text-gray-400 font-bold uppercase mb-2 md:mb-0" data-id="element-44">
                SIN SUPER COMBO
              </div>
              <div className="text-brand font-bold uppercase" data-id="element-45">COSTO REAL</div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-46">
              <div className="font-medium mb-2 md:mb-0" data-id="element-47">
                Lunes que empezás de cero
              </div>
              <div className="text-red-400 font-bold" data-id="element-48">
                12 veces por año mínimo
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-49">
              <div className="font-medium mb-2 md:mb-0" data-id="element-50">
                Hormonas desequilibradas sin información
              </div>
              <div className="text-red-400 font-bold" data-id="element-51">
                Años de metabolismo frenado
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-52">
              <div className="font-medium mb-2 md:mb-0" data-id="element-53">
                Dietas genéricas que no funcionan
              </div>
              <div className="text-red-400 font-bold" data-id="element-54">
                Tiempo, plata y energía perdida
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-55">
              <div className="font-medium mb-2 md:mb-0" data-id="element-56">Ayuno mal aplicado</div>
              <div className="text-red-400 font-bold" data-id="element-57">
                Más cortisol, más grasa abdominal
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-58">
              <div className="font-medium mb-2 md:mb-0" data-id="element-59">
                Sin sistema para eventos sociales
              </div>
              <div className="text-red-400 font-bold" data-id="element-60">
                Culpa + abandono cíclico
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-61">
              <div className="font-medium mb-2 md:mb-0" data-id="element-62">
                Sin protocolo para los días malos
              </div>
              <div className="text-red-400 font-bold" data-id="element-63">
                Un día malo = semana perdida
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between pb-2" data-id="element-64">
              <div className="font-medium mb-2 md:mb-0" data-id="element-65">
                El mismo ciclo el año que viene
              </div>
              <div className="text-red-400 font-bold" data-id="element-66">
                Exactamente el mismo punto de partida
              </div>
            </div>
          </div>
        </div>

        {/* FINAL CTA */}
        <div className="text-center" data-id="element-67">
          <h2 className="font-display font-black text-4xl md:text-6xl uppercase mb-8" data-id="element-68">
            El próximo lunes puede ser diferente.
          </h2>
          <Button size="xl" onClick={scrollToPricing} className="mb-6" data-id="element-69">
            QUIERO MI SUPER COMBO AHORA
          </Button>
          <p className="text-gray-500 font-medium" data-id="element-70">
            Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}